<template>
  <SetWorkerServiceTemplate
    :showBack="false"
    :showFinishDialog="false"
    @finish="onFinish"
  />
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import SetWorkerServiceTemplate from "@/components/templates/SetWorkerServiceTemplate.vue";
import { routerPush } from "@/utils/routerPush";

@Component({
  components: {
    SetWorkerServiceTemplate
  }
})
export default class SetWorkerService extends Vue {
  async onFinish() {
    await routerPush(this, { name: "CheckCompletedRegister" });
  }
}
</script>
